import { Component } from '@angular/core';
import { LoginService } from '../../../../login/login.service';

@Component({
  selector: 'app-menu-tecnico-generico',
  standalone: false,
  templateUrl: './menu-tecnico.component.html',
  styleUrl: './menu-tecnico.component.scss',
})
export class MenuTecnicoGenericoComponent {
  public permiso = LoginService.getPermisoActual();
}
